/*
  BetaTech (2026-11-03): sold-out products at the END of the collection grids, under every sort (client:
  "produktet e shitura me dal ne fund … nfund krejt"). Theme settings → "BetaTech – Listat e produkteve" →
  "Produktet pa stok në fund të listave" (settings.beta_soldout_last); switched off, the grid, snippets/pagination.liquid
  and assets/pagination.js work as before and this file is not loaded.

  Markup: sections/main-collection-product-grid.liquid in sold-out-last mode (pagination "Click to load", button "Ngarko
  më shumë"; the Search & Discovery availability filter present and not chosen, page 1) renders page 1 itself: the first
  products_per_page AVAILABLE products of a bigger scan (paginate by settings.beta_soldout_scan, default 100). Instead of
  snippets/pagination.liquid it renders snippets/beta-soldout-more.liquid: x-data="xBetaSoldoutLast('<section id>')"
  and a <script type="application/json" data-beta-sol-config> with the two list URLs, their counts and page counts, the
  total and the "Po shfaqen [item]/[total]" text.

  The rest of the list = two Shopify lists, each paginated natively (products_per_page) and fetched with the Section
  Rendering API (?section_id=<grid section>, credentials same-origin, no Accept header):
    1. the in-stock list: value.url_to_add of filter.v.availability = 1 (keeps the visitor's sort and filters);
    2. the sold-out list: value.url_to_add of filter.v.availability = 0.
  These requests are never pushed to the address bar; a sort or filter change (assets/facets.js) re-renders the section
  without a page, i.e. a new page 1 and a new component. Every .grid-item carries data-beta-pid (product id) and
  data-beta-available (product.available), and the grid is kept partitioned by what the CARD shows, because the filter
  index can lag product.available (2026-11-03: 3 of 486 gaming products):
    - a product already on screen (or waiting) is skipped (page 1 vs in-stock page 1, a product moved between requests);
    - an unavailable card from the in-stock pages waits and is added when the sold-out part starts (deferred);
    - an available card from the sold-out pages goes before the first sold-out card.
  One click adds at least products_per_page new cards when that many are left (at most 6 requests); the first click
  also fetches in-stock page 2 together with page 1 (page 1 of the in-stock list is mostly page 1 again). Hover or
  focus on the button prefetches the next request only. The whole .grid-item is inserted (pagination.js inserts its
  innerHTML; no CSS targets .grid-item or the children of #ItemsGrid). After a click that started from the keyboard,
  the focus moves to the first new card (in the grid's order). On an error the message shows and the next click
  retries the same request.
  Safety net (decision D6, 2026-11-03: B2B buyers could not be checked): every answer carries its paginate.items
  (data-beta-items). An 'in' / 'out' answer that is not the filtered list Liquid counted (the whole list, no grid
  while products were counted) means the filter is not applied for this visitor: the rest of the list then comes in
  Shopify's own order (both filter values = every product), nothing lost or doubled. If Shopify ignores the filter
  without marking it chosen, Liquid renders page 1 of that list in this mode again: the script then goes on with the
  native pages 2… (pagesAfter); only the sold-out products of the native page 1 cannot come in that case.
  A list that changes while the visitor clicks through it (review 2026-11-03: a sale or a delivery moves a product from
  one list to the other; Shopify's own list does not move then): each answer's size (data-beta-items) is compared with
  the previous answer of the same list (resync). Smaller = products moved up into pages already read: those pages are
  read again first (the storefront answers "max-age=0, must-revalidate", so a new request gets the list as it is now),
  repeats skipped. Any change marks the state; if the end then shows fewer products than the list has (a product moved
  into a list already read), the whole list is read once more in Shopify's own order and only the missing cards go in,
  partitioned like the rest (needsRepair / startRepair).

  window.BetaSoldoutLast exposes the pure helpers and the component for tests/beta-soldout-last.jxa.js: addParams,
  phaseUrl, createState, nextRequest, advance, plan, fill, parseGrid, firstInOrder, honoured, fallBack, allUrl,
  pagesAfter, resync, needsRepair, startRepair, component.
*/
(function () {
  'use strict';

  if (window.BetaSoldoutLast && window.BetaSoldoutLast.booted) return;

  var MAX_REQUESTS_PER_CLICK = 6;

  function noop() {}

  function decode(value) {
    try {
      return decodeURIComponent(String(value).replace(/\+/g, ' '));
    } catch (e) {
      return String(value);
    }
  }

  // '/collections/gaming?filter.v.availability=1&sort_by=price-ascending' + { page: 3, section_id: 'x' }
  // → '/collections/gaming?filter.v.availability=1&sort_by=price-ascending&page=3&section_id=x'
  // A key already in the query is replaced; null / '' removes it. The #hash is dropped.
  function addParams(base, params) {
    var url = String(base == null ? '' : base).split('#')[0];
    var at = url.indexOf('?');
    var path = at < 0 ? url : url.slice(0, at);
    var parts = at < 0 ? [] : url.slice(at + 1).split('&');
    var names = Object.keys(params || {});
    var kept = [];
    for (var i = 0; i < parts.length; i++) {
      if (!parts[i]) continue;
      var eq = parts[i].indexOf('=');
      var key = decode(eq < 0 ? parts[i] : parts[i].slice(0, eq));
      if (names.indexOf(key) >= 0) continue;
      kept.push(parts[i]);
    }
    for (var j = 0; j < names.length; j++) {
      var value = params[names[j]];
      if (value === null || value === undefined || value === '') continue;
      kept.push(encodeURIComponent(names[j]) + '=' + encodeURIComponent(String(value)));
    }
    return path + (kept.length ? '?' + kept.join('&') : '');
  }

  function phaseUrl(base, page, sectionId) {
    return addParams(base, { page: page > 1 ? page : null, section_id: sectionId });
  }

  function toCount(value) {
    var number = parseInt(value, 10);
    return number > 0 ? number : 0;
  }

  // cfg from Liquid: inPages / outPages (the filter values' counts / products_per_page, rounded up), inCount / outCount
  // (the counts), total (the whole list). 'all' = the fallback list (see fallBack), unused until then.
  function createState(cfg) {
    var inPages = toCount(cfg && cfg.inPages);
    var outPages = toCount(cfg && cfg.outPages);
    return {
      inPage: 1, inPages: inPages, inDone: inPages === 0,
      outPage: 1, outPages: outPages, outDone: outPages === 0,
      all: false, allPage: 1, allPages: 0, allDone: true,
      inCount: toCount(cfg && cfg.inCount), outCount: toCount(cfg && cfg.outCount), total: toCount(cfg && cfg.total),
      deferred: [], seen: {},
      // resync: the size of the last answer per list; changed = a list changed while it was read; repair = the
      // final pass over Shopify's own list (startRepair)
      sizes: {}, changed: false, repair: false
    };
  }

  function nextRequest(state) {
    if (state.all) return state.allDone ? null : { phase: 'all', page: state.allPage };
    if (!state.inDone) return { phase: 'in', page: state.inPage };
    if (!state.outDone) return { phase: 'out', page: state.outPage };
    return null;
  }

  // Is the answer to an 'in' / 'out' request the filtered list Liquid counted? Its paginate.items (data-beta-items) is
  // that value's count, or at least less than the whole list (a count that moved by a sale since page 1 is fine). The
  // whole list (or more), no count, or no grid while products were counted = the filter is not applied for this visitor
  // (B2B buyers could not be checked on the store, 2026-11-03) or the index disagrees: then fallBack.
  function honoured(state, req, answer) {
    if (req.phase === 'all') return true;
    var expected = req.phase === 'in' ? state.inCount : state.outCount;
    if (answer.missing || answer.total < 0) return expected === 0;
    return answer.total === expected || answer.total < state.total;
  }

  // The rest of the list in Shopify's own order (today's order, nothing lost or doubled): the list with both values of
  // the filter (= every product, or the unfiltered list when the filter is ignored), from page 1, cards already on
  // screen skipped. The sold-out cards waiting (deferred) are dropped and come back in their own place.
  function fallBack(state) {
    state.all = true;
    state.allPage = 1;
    state.allPages = 0;
    state.allDone = false;
    state.inDone = true;
    state.outDone = true;
    for (var i = 0; i < state.deferred.length; i++) delete state.seen['p' + state.deferred[i].id];
    state.deferred = [];
  }

  // After the answer to req: pages = the answer's paginate.pages (0: unknown, keep the estimate), count = its cards.
  function advance(state, req, pages, count) {
    var p = req.phase;
    if (pages > 0) state[p + 'Pages'] = pages;
    if (count === 0 || req.page >= state[p + 'Pages']) {
      state[p + 'Done'] = true;
    } else {
      state[p + 'Page'] = req.page + 1;
    }
  }

  // Splits the cards of one answer: before = available, to go before the first sold-out card (or at the end);
  // after = sold out, appended; defer = sold-out cards of the in-stock list, appended when the sold-out part starts;
  // the fallback list ('all') is appended as it comes. Marks them in state.seen; skipped = cards already seen (shown or
  // waiting) or without a product id. The final pass of a repair (state.repair) is partitioned like the two lists.
  function plan(state, items, phase) {
    var out = { before: [], after: [], defer: [], skipped: 0 };
    for (var i = 0; i < (items || []).length; i++) {
      var item = items[i];
      if (!item || !item.id || state.seen['p' + item.id]) {
        out.skipped++;
        continue;
      }
      state.seen['p' + item.id] = true;
      if (phase === 'all' && !state.repair) {
        out.after.push(item);
      } else if (item.available) {
        out.before.push(item);
      } else if (phase === 'in') {
        out.defer.push(item);
      } else {
        out.after.push(item);
      }
    }
    return out;
  }

  // 'Po shfaqen [item]/[total]' + { item: 48, total: 486 } → 'Po shfaqen 48/486'
  function fill(template, values) {
    return String(template == null ? '' : template).replace(/\[(\w+)\]/g, function (match, key) {
      return values && values[key] != null ? String(values[key]) : match;
    });
  }

  // The cards of an answer (a section's HTML, or a Document): [{ id, available, html }] in grid order (only the
  // .grid-item children of #ItemsGrid, not the promotion blocks), its paging (data-beta-page / data-beta-pages), total =
  // its paginate.items (data-beta-items; -1 without it), missing = no #ItemsGrid (Shopify's "no products" text), mode =
  // the answer is itself a sold-out-last page 1 (its "load more" config is there; paged by the scan, not natively).
  function parseGrid(source) {
    var doc = source;
    if (typeof source === 'string') doc = new DOMParser().parseFromString(source, 'text/html');
    var grid = doc && doc.getElementById ? doc.getElementById('ItemsGrid') : null;
    if (!grid) return { items: [], pages: 0, page: 0, total: -1, missing: true, mode: false };
    var totalAttr = grid.getAttribute('data-beta-items');
    var items = [];
    var children = grid.children;
    for (var i = 0; i < children.length; i++) {
      var el = children[i];
      if (!el.classList || !el.classList.contains('grid-item')) continue;
      items.push({
        id: el.getAttribute('data-beta-pid') || '',
        available: el.getAttribute('data-beta-available') !== 'false',
        html: el.outerHTML
      });
    }
    return {
      items: items,
      pages: toCount(grid.getAttribute('data-beta-pages')),
      page: toCount(grid.getAttribute('data-beta-page')),
      total: totalAttr === null || totalAttr === '' ? -1 : toCount(totalAttr),
      missing: false,
      mode: !!(doc.querySelector && doc.querySelector('[data-beta-sol-config]'))
    };
  }

  // The page count to go on with after an answer: its own (data-beta-pages), except for page 1 of the fallback list
  // answered in sold-out-last mode again (Shopify ignored the filter without marking it chosen, so Liquid saw a plain
  // page 1): that page is paged by the scan, the native pages of 24 follow from page 2 (whole list / products_per_page).
  // The sold-out products of the native page 1 then never come (tools/demo/soldout, scenario "tablet"; docs/THEME.md).
  function pagesAfter(state, req, answer, perPage) {
    if (req.phase === 'all' && answer.mode) return Math.max(1, Math.ceil(state.total / (perPage || 24)));
    return answer.missing ? 1 : answer.pages;
  }

  // After an 'in' / 'out' answer: its list size (data-beta-items; -1 unknown) against the previous answer of the same
  // list. Another size = the list changed between the two requests (a sale, a delivery): state.changed. Smaller =
  // products moved up into pages already read, as many as it shrank: → the page to read again from (that one up to
  // req.page), else 0.
  function resync(state, req, total, perPage) {
    if (req.phase === 'all' || total < 0) return 0;
    var before = state.sizes[req.phase];
    state.sizes[req.phase] = total;
    if (before === undefined || before === total) return 0;
    state.changed = true;
    if (total > before || req.page < 2) return 0;
    return Math.max(1, req.page - Math.ceil((before - total) / (perPage || 24)));
  }

  // Both lists read (nothing waiting), a list changed meanwhile and fewer cards are on screen than the list has: a
  // product moved into a list already read (e.g. back in stock while the sold-out list was read). Once.
  function needsRepair(state, shown) {
    return state.changed && !state.all && !nextRequest(state) && !state.deferred.length && shown < state.total;
  }

  // The final pass: the list in Shopify's own order (both filter values), the cards not on screen yet partitioned.
  function startRepair(state) {
    fallBack(state);
    state.repair = true;
  }

  // The first of `nodes` in the order of `children` (the grid's children), or null: the card the focus goes to after
  // a click, also when cards went in before the first sold-out card.
  function firstInOrder(children, nodes) {
    for (var i = 0; i < (children || []).length; i++) {
      if (nodes.indexOf(children[i]) >= 0) return children[i];
    }
    return null;
  }

  // The fallback list: the in-stock URL with the sold-out value as well (both values of one filter = either)
  function allUrl(inUrl) {
    var url = String(inUrl == null ? '' : inUrl).split('#')[0];
    return url + (url.indexOf('?') < 0 ? '?' : '&') + 'filter.v.availability=0';
  }

  var helpers = {
    addParams: addParams, phaseUrl: phaseUrl, createState: createState, nextRequest: nextRequest,
    advance: advance, plan: plan, fill: fill, parseGrid: parseGrid, firstInOrder: firstInOrder,
    honoured: honoured, fallBack: fallBack, allUrl: allUrl, pagesAfter: pagesAfter, resync: resync,
    needsRepair: needsRepair, startRepair: startRepair
  };

  // ---------- the Alpine component (snippets/beta-soldout-more.liquid) ----------

  function component(sectionId) {
    return {
      busy: false,
      failed: false,
      hasMore: true,
      shownText: '',
      init: function () {
        var cfgEl = this.$el.querySelector('[data-beta-sol-config]');
        var cfg = {};
        try {
          cfg = JSON.parse(cfgEl ? cfgEl.textContent : '{}') || {};
        } catch (e) {
          cfg = {};
        }
        this.setup(cfg, document.getElementById('ItemsGrid'));
        // page 1 is short (fewer than products_per_page available products in the scan, more in stock): fill it now
        if (cfg.short) this.more();
      },
      setup: function (cfg, grid) {
        this.cfg = cfg || {};
        this.perPage = toCount(this.cfg.perPage) || 24;
        this.total = toCount(this.cfg.total);
        this.grid = grid || null;
        this.state = createState(this.cfg);
        this.cache = {};
        var cards = this.grid ? this.grid.querySelectorAll('.grid-item[data-beta-pid]') : [];
        for (var i = 0; i < cards.length; i++) this.state.seen['p' + cards[i].getAttribute('data-beta-pid')] = true;
        this.update();
      },
      urlFor: function (req) {
        var base = req.phase === 'in' ? this.cfg.inUrl : req.phase === 'out' ? this.cfg.outUrl : allUrl(this.cfg.inUrl);
        return phaseUrl(base, req.page, sectionId);
      },
      load: function (req) {
        var url = this.urlFor(req);
        var cache = this.cache;
        if (cache[url]) return cache[url];
        // Credentials for the B2B buyer's prices; no Accept header (with "application/json" Shopify answers a
        // collection URL with its JSON instead of the section: assets/beta-b2b-catalog.js, 2026-11-03).
        var request = window.fetch(url, { credentials: 'same-origin' }).then(function (response) {
          if (!response.ok) throw new Error('HTTP ' + response.status);
          return response.text();
        }).then(function (html) {
          return parseGrid(html);
        });
        cache[url] = request;
        request.catch(function () {
          if (cache[url] === request) delete cache[url]; // retried by the next click
        });
        return request;
      },
      // hover / focus on the button: only the request the next click starts with
      prefetch: function () {
        if (this.busy || !this.state) return;
        var req = nextRequest(this.state);
        if (req) this.load(req).catch(noop);
      },
      // Puts the cards in the grid: 'before' = before the first sold-out card (at the end when there is none),
      // 'after' = at the end. The new nodes are added to `inserted`. Returns how many went in.
      insert: function (items, where, inserted) {
        var grid = this.grid;
        if (!items.length || !grid) return 0;
        var html = '';
        for (var i = 0; i < items.length; i++) html += items[i].html;
        var holder = document.createElement('template');
        holder.innerHTML = html;
        var nodes = Array.prototype.slice.call(holder.content.children);
        var anchor = where === 'before' ? grid.querySelector(':scope > .grid-item[data-beta-available="false"]') : null;
        grid.insertBefore(holder.content, anchor);
        for (var j = 0; j < nodes.length; j++) inserted.push(nodes[j]);
        return nodes.length;
      },
      flushDeferred: function (inserted) {
        var items = this.state.deferred;
        this.state.deferred = [];
        return this.insert(items, 'after', inserted);
      },
      // true when the focus is on this button and came from the keyboard: a mouse click focuses the button in some
      // browsers, and then the focus stays (no jump of the page)
      keyboardFocus: function () {
        var active = document.activeElement;
        if (!active || !this.$el || !this.$el.contains(active)) return false;
        try {
          return active.matches(':focus-visible');
        } catch (e) {
          return true;
        }
      },
      // the first new card in the grid's order, its first link in the tab order (the photo link has tabindex="-1")
      focusFirst: function (inserted) {
        var card = firstInOrder(this.grid.children, inserted);
        var link = card ? card.querySelector('a[href]:not([tabindex="-1"])') || card.querySelector('a[href]') : null;
        if (link) link.focus();
      },
      // One click: the next requests, in order, until products_per_page new cards are in, nothing is left or 6 requests
      // were made. A promise chain (no async / await), so tests/beta-soldout-last.jxa.js runs it with a synchronous one.
      more: function () {
        var self = this;
        if (this.busy || !this.state) return Promise.resolve();
        var grid = this.grid;
        var keyboard = this.keyboardFocus();
        var inserted = [];
        var added = 0;
        var detached = false;
        this.busy = true;
        this.failed = false;
        var first = nextRequest(this.state);
        if (first) {
          this.load(first).catch(noop);
          if (first.phase === 'in' && first.page === 1 && this.state.inPages > 1) this.load({ phase: 'in', page: 2 }).catch(noop);
        }
        var step = function (n) {
          if (n >= MAX_REQUESTS_PER_CLICK || added >= self.perPage) return null;
          var req = nextRequest(self.state);
          if (!req && needsRepair(self.state, self.shownCount())) {
            startRepair(self.state);
            req = nextRequest(self.state);
          }
          if (!req) return null;
          var url = self.urlFor(req);
          return self.load(req).then(function (answer) {
            if (!grid || !grid.isConnected) {
              detached = true; // the grid was re-rendered (sort / filter change): drop the answer
              return null;
            }
            delete self.cache[url]; // used: the state moves past it
            if (!honoured(self.state, req, answer)) {
              fallBack(self.state); // the filter is not applied for this visitor: Shopify's own order from here
              return step(n + 1);
            }
            var from = resync(self.state, req, answer.total, self.perPage);
            if (from) {
              // the list shrank since its last answer: its pages from `from` again first, then this one (kept)
              self.state[req.phase + 'Page'] = from;
              self.cache[url] = Promise.resolve(answer);
              return step(n + 1);
            }
            var parts = plan(self.state, answer.items, req.phase);
            added += self.insert(parts.before, 'before', inserted);
            added += self.insert(parts.after, 'after', inserted);
            for (var d = 0; d < parts.defer.length; d++) self.state.deferred.push(parts.defer[d]);
            var wasIn = !self.state.inDone;
            advance(self.state, req, pagesAfter(self.state, req, answer, self.perPage), answer.missing ? 0 : answer.items.length);
            if (wasIn && self.state.inDone) added += self.flushDeferred(inserted);
            return step(n + 1);
          });
        };
        var done = function (error) {
          try {
            if (error) self.failed = true;
            if (detached) return;
            if (!error && !nextRequest(self.state) && self.state.deferred.length) self.flushDeferred(inserted);
            // also the cards of the requests before a failed one: the theme's scroll animation shows them
            // (assets/animation-card.js, data-active="false" until observed)
            if (inserted.length && typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger();
            if (keyboard && inserted.length) self.focusFirst(inserted);
          } catch (e) {
            self.failed = true;
          } finally {
            self.busy = false;
            self.update();
          }
        };
        return Promise.resolve()
          .then(function () {
            return step(0);
          })
          .then(function () {
            done(false);
          }, function () {
            done(true);
          });
      },
      shownCount: function () {
        return this.grid ? this.grid.querySelectorAll('.grid-item').length : 0;
      },
      update: function () {
        var shown = this.shownCount();
        this.hasMore = !!nextRequest(this.state) || this.state.deferred.length > 0 || needsRepair(this.state, shown);
        this.shownText = fill(this.cfg.showing, { item: shown, total: Math.max(this.total, shown) });
      }
    };
  }

  helpers.component = component;
  helpers.booted = true;
  window.BetaSoldoutLast = helpers;

  if (typeof document === 'undefined' || !document || typeof document.addEventListener !== 'function') return;
  var register = function () {
    window.Alpine.data('xBetaSoldoutLast', component);
  };
  if (window.Alpine && typeof window.Alpine.data === 'function' && window.Alpine.version) {
    // Alpine already started (script added late): register now; Alpine initialises the button when it sees it.
    register();
  } else {
    document.addEventListener('alpine:init', register);
  }
})();
